import PropTypes from 'prop-types';
import Text from 'ol/style/Text';
import Fill from 'ol/style/Fill';

clusterText.propTypes = {
  /**
   * Text style function for single features.
   */
  labelText: PropTypes.func,
  /**
   * Font
   */
  font: PropTypes.string,
  /**
   * Text color
   */
  color: PropTypes.string,
  /**
   * Text align
   */
  textAlign: PropTypes.string,
  /**
   * Text padding in pixels.
   */
  padding: PropTypes.arrayOf(PropTypes.number),
  /**
   * Label horizontal offset in pixels.
   */
  offsetX: PropTypes.number,
  /**
   * Label vertical offset in pixels (positive values offset downwards).
   */
  offsetY: PropTypes.number,
  /**
   * Rotation in radians (positive rotation clockwise).
   */
  rotation: PropTypes.number
};

/**
 * Text style for cluster text. Renders the number of features. For single features, renders nothing or delegates to the provided labelText.
 * @component
 */
export default function clusterText(_ref) {
  var font = _ref.font,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'rgb(255,255,255)' : _ref$color,
      textAlign = _ref.textAlign,
      padding = _ref.padding,
      offsetX = _ref.offsetX,
      offsetY = _ref.offsetY,
      rotation = _ref.rotation,
      labelText = _ref.labelText;

  return function (cluster, resolution) {
    var features = cluster.get('features');
    var size = features.length;

    if (size === 1) {
      return labelText && labelText(features[0], resolution);
    }

    return new Text({
      text: size.toString(),
      fill: new Fill({
        color: color || 'rgb(255,255,255)'
      }),
      font: font || '10px sans-serif',
      offsetX: offsetX,
      offsetY: offsetY,
      textAlign: textAlign,
      padding: padding,
      rotation: rotation
    });
  };
}